import { signal, Signal } from "@angular/core";
import { Dashboard, FlexDashboard } from "../models/dashboard";
import { WidgetFactory } from "./widget.factory";
import { FlexDashboardWidgetLayout } from "../flex-dashboard/flex-dashboard.component";

export class DashboardFactory {
    /**
     * Erzeugt ein neues leeres Vendor-Objekt für die Erstellung eines Lieferanten.
     */
  static createEmpty(): Dashboard {
      return {createdAt: new Date(), updatedAt: new Date(), id: 0, name: '', description: '', widgets: [], icon: 'pi pi-home' };
  }
  
 
    /**
     * Wandelt ein bestehendes Relation-Objekt in ein Signal für die Bearbeitung (UpdateVendor) um.
     */
    static fromCreateDashboard(dashboard: Dashboard): Signal<Dashboard> {
      return signal({ ...dashboard });
    }
  
    static createWelcomeDashboard(): Dashboard {
      return {
          id: -1,
          name: 'Willkommen',
          description: 'Standard-Dashboard',
          createdAt: new Date(),
          updatedAt: new Date(),
          widgets: WidgetFactory.createWelcomeWidgets(),
          icon: 'home' // Tabler-Name (DS-Sidebar); Backend-Dashboards liefern weiter pi-Klassen
        };
  }

      static createWelcomeDashboardFlex(hasReportsAccess: boolean = true): FlexDashboard {
      return {
          id: -1,
          name: 'Willkommen',
          description: 'Standard-Dashboard',
          createdAt: new Date(),
          updatedAt: new Date(),
          widgets: WidgetFactory.createWelcomeWidgetsFlex(hasReportsAccess),
          icon: 'home', // Tabler-Name (DS-Sidebar)
          layoutMode: hasReportsAccess ? 'two-column' : 'single-column',
        };
  }


  }
  